
var editableAreaLess = {};
import genaration from '../../utils/classname';
export var editableAreaClass = genaration(editableAreaLess, 'editableArea');